// extracted by mini-css-extract-plugin
export var circle = "_1f-2";
export var icon = "_1f-a";
export var iconHighlight = "_1f-0";
export var lg = "_1f-8";
export var md = "_1f-7";
export var outline = "_1f-4";
export var sm = "_1f-6";
export var square = "_1f-1";
export var xl = "_1f-9";
export var xs = "_1f-5";
export var xxs = "_1f-3";